import React from "react";
import "./AddressCollector.css";
// import axios from "axios";
import { FaUserEdit, FaShieldAlt, FaCheckCircle } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";

import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

export default class AddressCollector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: "",
      lname: "",
      country: "",
      city: "",
      addr: "",
      phone: "",
      email: "",

      region: "",

      is_valid_fname: false,
      is_valid_lname: false,
      is_valid_country: false,
      is_valid_city: false,
      is_valid_addr: false,
      is_valid_phone: false,
      is_valid_email: false,

      show_form_errors: false,
      form_is_valid: false,
    };
    this.updateField = this.updateField.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
  }

  selectCountry(val) {
    //this.setState({ country: val });
    let event = {
      target: {
        name: "country",
        value: val,
      },
    };
    this.updateField(event);
  }

  updateAddress() {
    if (this.state.form_is_valid) {
      return this.props.outputAddress(this.state);
    } else {
      this.setState({ show_form_errors: true });
      return false;
    }
  }

  updateField(event) {
    console.log("Update field event: ", event.target.name);
    let nam = event.target.name;
    let val = event.target.value;
    let stateVarName = "is_valid_" + nam;
    let formIsValid = 0;
    console.log("FIELD EVENT:", event);
    formIsValid += !this.state.is_valid_fname ? 1 : 0;
    formIsValid += !this.state.is_valid_lname ? 1 : 0;
    formIsValid += !this.state.is_valid_country ? 1 : 0;
    formIsValid += !this.state.is_valid_city ? 1 : 0;
    formIsValid += !this.state.is_valid_addr ? 1 : 0;
    formIsValid += !this.state.is_valid_phone ? 1 : 0;
    formIsValid += val !== "" ? -1 : 1;
    formIsValid > 0
      ? this.setState({ form_is_valid: false })
      : this.setState({ form_is_valid: true });
    this.setState({ [nam]: val });
    val !== ""
      ? this.setState({ [stateVarName]: true })
      : this.setState({ [stateVarName]: false });
  }

  render() {
    return (
      <div className="shipping_collector_container">
        <div className="address_collector_bubble">
          <div className="bubble_title" onClick={this.props.editAddress}>
            {this.props.addressLabel}
            <span className="shieldIcon">
              <FaShieldAlt />
            </span>
            {this.state.form_is_valid ? (
              <span className="completeIcon">
                <FaCheckCircle color="green" />
              </span>
            ) : (
              <span className="completeIcon">
                <FaUserEdit />
              </span>
            )}
          </div>
          {this.props.showInputFields ? (
            <div>
              <input
                type="text"
                name="fname"
                placeholder="Име"
                key="fname"
                value={this.state.fname}
                className={
                  !this.state.is_valid_fname && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />
              <input
                type="text"
                name="lname"
                placeholder="Фамилия"
                key="lname"
                value={this.state.lname}
                className={
                  !this.state.is_valid_lname && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />

              <CountryDropdown
                value={this.state.country}
                onChange={(val) => this.selectCountry(val)}
                valueType="short"
                classes={
                  !this.state.is_valid_country && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
              />

              <input
                type="text"
                name="city"
                placeholder="Град"
                key="city"
                value={this.state.city}
                className={
                  !this.state.is_valid_city && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />
              <input
                type="text"
                name="addr"
                placeholder="Адрес"
                key="addr"
                value={this.state.addr}
                className={
                  !this.state.is_valid_addr && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />
              <input
                type="text"
                name="phone"
                placeholder="Телефон"
                key="phone"
                value={this.state.phone}
                className={
                  !this.state.is_valid_phone && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />
              <input
                type="text"
                name="email"
                placeholder="E-mail"
                key="email"
                value={this.state.email}
                className={
                  !this.state.is_valid_email && this.state.show_form_errors
                    ? "collectorFormInput addrInputWithErrors"
                    : "collectorFormInput"
                }
                onChange={this.updateField}
              />
            </div>
          ) : (
            false
          )}
        </div>
        {this.props.showInputFields ? (
          <button className="confirmButton" onClick={this.updateAddress}>
            Продължи
          </button>
        ) : (
          false
        )}
      </div>
    );
  }
}
